import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5366fc96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row q-col-gutter-lg" }
const _hoisted_2 = { id: "circularProgressContainer" }
const _hoisted_3 = {
  class: "col-xs-8",
  id: "pageTitleContainer"
}
const _hoisted_4 = {
  class: "text-h4 text-weight-bold",
  id: "pageTitle"
}
const _hoisted_5 = {
  key: 0,
  class: "q-py-xs",
  id: "pageDescription"
}
const _hoisted_6 = {
  class: "q-py-xs",
  id: "pageContent"
}
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CircularProgress = _resolveComponent("CircularProgress")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_option_group = _resolveComponent("q-option-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_CircularProgress)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.title)), 1),
        (_ctx.description)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t(_ctx.description)), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_q_separator, {
      class: "q-my-md",
      id: "separator"
    }),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("span", {
        innerHTML: _ctx.$t(_ctx.content)
      }, null, 8, _hoisted_7)
    ]),
    _createVNode(_component_q_option_group, {
      id: "radioBtnOptionGroup",
      options: [{ label: _ctx.$t('portal_btnAgree'), value: true }, { label: _ctx.$t('portal_btnDisagree'), value: false }],
      type: "radio",
      modelValue: _ctx.portal.dataPolicyAgreed,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.portal.dataPolicyAgreed) = $event))
    }, null, 8, ["options", "modelValue"])
  ], 64))
}